<template>
<div>
    <Row>
      <Col style="padding-top: 10px">
            <div class="Company_Detail" v-if="orderDetail">
                <Row>
                  <Col span="18">
                      <span style="font-weight: bolder;font-size: x-large"> #{{orderDetail.orderNumber}}</span>
                    ({{orderDetail.clientobject.address[0].city}})
                  </Col>
                  <Col span="6">
                    <Badge :text="priorityObj[orderDetail.priority]"
                           :class-name="'badge-' + priorityObj[orderDetail.priority]"></Badge>
                  </Col>
                  <Col span="10">
                    <span>{{orderDetail.materials.type}} </span>
                    <span><strong>{{orderDetail.materials.kg}} KG</strong></span>
                  </Col>
                  <Col span="14">
                    <Tag color="default">
                      <span style="font-weight: bold">INTERNAL</span> - <span style="text-transform: capitalize">{{orderDetail.internalStatus.name}}</span></Tag><br>
                    <Tag color="default">
                      <span style="font-weight: bold">EXTERNAL</span> - <span style="text-transform: capitalize">{{orderDetail.externalStatus.name}}</span></Tag>
                  </Col>
                </Row>
                <Divider></Divider>
                <Row>
                  <Col span="24">
                    <span class="label-text">Dealer  </span>
                    <Poptip placement="right" width="250" trigger="hover" title="Dealer Address" word-wrap>
                      <Icon type="md-pin"></Icon>
                      <div class="api" slot="content">{{orderDetail.clientobject.address[0].add1}}, {{orderDetail.clientobject.address[0].add2}}, {{orderDetail.clientobject.address[0].area}}, {{orderDetail.clientobject.address[0].city}}, {{orderDetail.clientobject.address[0].state}} - {{orderDetail.clientobject.address[0].pincode}}
                      </div>
                    </Poptip>
                    <p>{{orderDetail.clientobject.name}}</p>
                    <p>{{orderDetail.clientobject.mobile}}</p>
                    <p>{{orderDetail.clientobject.email}}</p>
                  </Col>
                </Row>
                <Row>
                  <Col span="12">
                    <span class="label-text">Pickup Party  </span>
                    <Poptip placement="right" width="250" trigger="hover" title="PickupParty Address" word-wrap>
                      <Icon type="md-pin"></Icon>
                      <div class="api" slot="content">{{orderDetail.pickuppartyobject.address[0].add1}}, {{orderDetail.pickuppartyobject.address[0].add2}}, {{orderDetail.pickuppartyobject.address[0].area}}, {{orderDetail.pickuppartyobject.address[0].city}}, {{orderDetail.pickuppartyobject.address[0].state}} - {{orderDetail.pickuppartyobject.address[0].pincode}}
                      </div>
                    </Poptip>
                    <p>{{orderDetail.pickuppartyobject.name}}</p>
                    <p>{{orderDetail.pickuppartyobject.mobile}}</p>
                    <p>{{orderDetail.pickuppartyobject.email}}</p>
                  </Col>
                  <Col span="12">
                    <span class="label-text">Dropping Party  </span>
                    <Poptip placement="right" width="250" trigger="hover" title="DropParty Address" word-wrap>
                      <Icon type="md-pin"></Icon>
                      <div class="api" slot="content">{{orderDetail.droppingpartyobject.address[0].add1}}, {{orderDetail.droppingpartyobject.address[0].add2}}, {{orderDetail.droppingpartyobject.address[0].area}}, {{orderDetail.droppingpartyobject.address[0].city}}, {{orderDetail.droppingpartyobject.address[0].state}} - {{orderDetail.droppingpartyobject.address[0].pincode}}
                      </div>
                    </Poptip>
                    <p>{{orderDetail.droppingpartyobject.name}}</p>
                    <p>{{orderDetail.droppingpartyobject.mobile}}</p>
                    <p>{{orderDetail.droppingpartyobject.email}}</p>
                  </Col>
                  <Divider></Divider>
       <!-- ------------------------- Other Details ----------------------------- -->
                  <template v-if="orderDetail.orderDetails">
                    <Col span="24"><strong>Other Details</strong></Col>
                  <Col span="8" class="label-text">Pickup Confirmation</Col>
                  <Col span="16">{{orderDetail.orderDetails.pickupConfirmation}}</Col>
                  <Col span="8" class="label-text">Order Readiness</Col>
                  <Col span="16">{{orderDetail.orderDetails.orderReadiness.isOrderReady?'Yes':'No'}}
                  <span v-if="!orderDetail.orderDetails.orderReadiness.isOrderReady">
                    | {{formatDate(orderDetail.orderDetails.orderReadiness.pickupDate)}}</span></Col>
                  <Col span="8" class="label-text">LR Ready</Col>
                  <Col span="16">{{orderDetail.orderDetails.lrObject.islrReady?'Yes':'No'}}</Col>
                  <Col span="8" class="label-text">Email Confirmation</Col>
                  <Col span="16">{{orderDetail.orderDetails.lrObject.isEmailSent?'Yes':'No'}}</Col>
                  <Row><Col span="8" class="label-text">Pickup Location</Col>
                    <Col span="16">
                    <span v-if="orderDetail.orderDetails.pickupPoint.pickupPartyName">
                      {{orderDetail.orderDetails.pickupPoint.pickupPartyName}}<br></span>
                    <span v-if="orderDetail.orderDetails.pickupPoint.add1">
                      {{orderDetail.orderDetails.pickupPoint.add1}},
                      {{orderDetail.orderDetails.pickupPoint.add2}}<br></span>
                    <span v-if="orderDetail.orderDetails.pickupPoint.city">
                      {{orderDetail.orderDetails.pickupPoint.area}},
                      {{orderDetail.orderDetails.pickupPoint.city}}<br></span>
                    <span v-if="orderDetail.orderDetails.pickupPoint.state">
                      {{orderDetail.orderDetails.pickupPoint.state}} -
                      {{orderDetail.orderDetails.pickupPoint.pincode}}</span>
                     </Col></Row>
                  <Row><Col span="8" class="label-text">Pickup Vehicle</Col>
                    <Col span="16">
                     <span v-if="orderDetail.orderDetails.PIckupTempo">{{orderDetail.orderDetails.PIckupTempo.tempo.name}} ↔ {{orderDetail.orderDetails.PIckupTempo.driverDetail.name}}</span>
                     <span v-else-if="orderDetail.orderDetails.PickupTruck">{{orderDetail.orderDetails.PickupTruck.truck.name}} ↔ {{orderDetail.orderDetails.PickupTruck.driverDetail.name}}</span>
                   </Col></Row>
                    <Row><Col span="8" class="label-text">Transport Vehicle</Col>
                      <Col span="16">
                        <span v-if="orderDetail.orderDetails.truckOrder">{{orderDetail.orderDetails.truckOrder.truck.name}} ↔ {{orderDetail.orderDetails.truckOrder.driverDetail.name}}</span>
                      </Col></Row>

                  </template>
       <!-- ------------- x---------x-----------x---------x----------x-------------- -->
                </Row>
              </div>
            <div v-else>
              There is no Order Detail Available.
            </div>

      </Col>
    </Row>

</div>
</template>

<script>
  import { GET_SINGLE_ORDER } from '../graphql/queries/Orders'
  import {SUBSCRIBE_SINGLE_ORDER} from '../graphql/subscription/Orders'
  import { GET_SINGLE_TEMPO_ORDER } from '../graphql/queries/tempoOrders'
  import { GET_SINGLE_TRUCK_ORDER } from '../graphql/queries/truckOrders'
  import moment from 'moment'
  export default {
    apollo: {
        orders: {
            query: GET_SINGLE_ORDER,
            variables() {
                return {
                    orderId: this.orderId
                }
            },
            skip: false,
            subscribeToMore: {
                document: SUBSCRIBE_SINGLE_ORDER,
                variables() {
                    return {
                        orderId: this.orderId
                    }
                },
                updateQuery: function(previousResult, { subscriptionData }) {
                    if(subscriptionData.data.orders.length){
                        this.orderDetail = subscriptionData.data.orders[0];
                        this.emitOrderData(subscriptionData.data.orders[0])
                    }
                },
            },
            result ({ data, loading }) {
                if (!loading && data.orders.length) {
                    this.orderDetail = data.orders[0];
                    this.emitOrderData(data.orders[0])
                }
            }
        },
    },
    name: 'OrderDetail',
    props: ['orderId'],
    data () {
      return {
        query_GET_SINGLE_TEMPO_ORDER: GET_SINGLE_TEMPO_ORDER,
        query_GET_SINGLE_TRUCK_ORDER: GET_SINGLE_TRUCK_ORDER,
        orderDetail: null,
        priorityObj: {0: 'Low', 1: 'Normal', 2: 'High'},
        assignTempoOrder : null,
        assignTruckOrder : null
      }
    },
    methods: {
      formatDate(date){
          return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY')
      },
      emitOrderData(orderData){
        this.$emit('orderData', orderData);
        this.assignTempoOrder = null;
        this.assignTruckOrder = null;
       //  /* --------- Get Vehicle & Driver Details on separate call ------- */
       //  if(orderData.orderDetails && orderData.orderDetails.pickupVehicleAssignId){
       //      this.getTempoOrder(orderData.orderDetails.pickupVehicleAssignId);
       //  }
       //  if(orderData.orderDetails && orderData.orderDetails.transportVehicleAssignId){
       //      this.getTruckOrder(orderData.orderDetails.transportVehicleAssignId);
       //  }
       // /* --------x-----------x------------x------------x---------x-------- */
      },
      async getTempoOrder(tempoOrderId){
          let response = await this.$apollo.query({
              query: this.query_GET_SINGLE_TEMPO_ORDER,
              variables: {
                  tempoOrderId: tempoOrderId
              }
          })
          if(response.data){
              this.assignTempoOrder = response.data.singleTempoOrders[0]
          }
      },
      async getTruckOrder(truckOrderId){
          let response = await this.$apollo.query({
              query: this.query_GET_SINGLE_TRUCK_ORDER,
              variables: {
                  truckOrderId: truckOrderId
              }
          })
          if(response.data){
              this.assignTruckOrder = response.data.truckOrders[0]
          }
      },
      companyType (id) {
        return this.$parent.companyType.find(type => type.id === id).name
      }
    }
  }
</script>

<style scoped>
  .badge-Low{
    background: #F2D600 !important;
    color: black;
  }
  .badge-Normal{
    background: #FF9F1A !important;
  }
  .badge-High{
    background: #EB5A46 !important;
  }
  .Company_Detail {
    font-size: medium;
  }
  .label-text{
    font-size: 14px;
    color: #858585
  }
</style>
